import { styled } from "../../styled-components";
import { Block } from "../Block/Block";

const Spacer = styled(Block)`
  flex: 1;
`;

export { Spacer };
